import { useTranslation } from 'react-i18next';
import { FormatSpecsAdmin } from '@/features/format-specs-admin';
import { AdminPageShell } from '../AdminPageShell';

export function AdFormatsPage() {
  const { t } = useTranslation('admin');
  return (
    <AdminPageShell title={t('admin.adFormats.title')}>
      <FormatSpecsAdmin />
    </AdminPageShell>
  );
}
